<template>
  <div id="select-flavors" class="d-flex flex-column">
    <h4 style="font-size: 26px;" class="mt-5"><span class="text-red">Stap 2/4</span> - KIES JE SMAKEN</h4>
    <div class="col-12 mb-3 d-flex veganarea mt-3">
      <label class="switch">
        <input type="checkbox" v-model="veganOnly" />
        <span class="slider round"></span>
      </label>
      <span class="mt-1 ms-2">Alleen vegan</span>
    </div>
    <p v-if="flavorError" class="text-danger flavor-danger">* Selecteer het vereiste aantal smaken om door te gaan.</p>
    <div v-if="boxSize > 0" :class="`d-flex align-items-center gap-2 sd-smaak-vulvlak flex-wrap bg-white shadow-sm rounded-4 pe-0 p-3 mt-2 ${boxSize >= 4 ? 'justify-content-evenly' : ''}`">
      <div v-for="index in boxSize" :key="index" class="position-relative text-start box-container flavour-block d-flex align-items-center">
        <div v-if="flavours.length > index - 1" class="d-flex align-items-center justify-content-center pb-3 picked-flavor-wrapper rounded-pill position-relative">
          <span 
            v-if="!flavours[index - 1].required"
            role="button" 
            class="sd-smaak-close-btn rounded-pill mt-2 me-2 position-absolute top-0 end-0 d-flex align-items-center justify-content-center" 
            @click="$emit('removeflavour', index - 1)"
          >
          <svg style="width: 18px; height: 18px;" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 6v-.8c0-1.13 0-1.69-.22-2.11 -.2-.38-.5-.69-.88-.88 -.43-.22-.99-.22-2.11-.22h-1.6c-1.13 0-1.69 0-2.11.21 -.38.19-.69.49-.88.87 -.22.42-.22.98-.22 2.1v.8m2 5.5v5m4-5v5m-11-10.5h18m-2 0v11.2c0 1.68 0 2.52-.33 3.16 -.29.56-.75 1.02-1.32 1.31 -.65.32-1.49.32-3.17.32h-4.4c-1.69 0-2.53 0-3.17-.33 -.57-.29-1.03-.75-1.32-1.32 -.33-.65-.33-1.49-.33-3.17V5.94"/>
              </svg>
          </span>
          <img :src="flavours[index - 1].image" width="100" class="evj-selected-flavor d-flex align-items-center" />
        </div>
        <div v-else class="flavor-bg-example d-flex align-items-center justify-content-center rounded-pill sd-small-bg-example" style="background: url('https://sweetdeliver.nl/wp-content/uploads/2024/09/example.webp');">
          <div class="my-auto d-flex align-items-center justify-content-center bg-white rounded-pill">
            <p>{{index}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="rounded-4 mt-4">
      <div class="flavor-grid">
        <div v-for="flavour in filteredFlavours" :key="flavour.id" class="position-relative">
          <div 
            role="button" 
            class="text-start position-relative bg-flavor flavor-btn h-100 text-white flex-column box-container rounded-3 p-1 p-md-3 pb-1 pb-md-2 flavour-block d-flex" 
            :class="{ 
              'opacity-75': flavour.required,
              'flavor-selected': selectedFlavors.has(flavour.id)
            }"
            @click="handleFlavorClick(flavour)"
          >
          <img v-if="flavour.vegan === '1'" class="vegan-icon position-absolute end-0 top-0" src="https://sweetdeliver.nl/wp-content/uploads/2024/09/vegan-icon.svg" width="34px" />
            <span class="sd-smaak-tooltip position-absolute" @click.stop="$emit('showmodal', flavour)">
              i
            </span>
            <div class="flavor-bg d-flex mx-auto rounded-pill align-items-center justify-content-center">
              <img :src="flavour.image" width="50px" />
            </div>
            <div class="d-flex flex-column align-items-center">
              <p class="flavor-text font-anton fw-bold text-center z-1 w-100 mx-auto mb-0" style="font-size: 19px;">
                {{ flavour.name }}
              </p>
              <span v-if="flavour.required" class="badge bg-danger mt-1">Verplicht</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, defineProps, defineEmits } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
  boxdata: {
    type: Object,
    required: true
  },
  flavors: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['pickflavour', 'removeflavour', 'showmodal', 'update:flavours', 'update:veganOnly']);

const veganOnly = ref(props.boxdata.veganOnly ?? false);
const flavorError = ref(false);
const selectedFlavors = ref(new Set());
const route = useRoute();
const path = computed(() => route.fullPath);

const boxSize = computed(() => {
  if (!props.boxdata?.pickedBox?.product_options?.aantal_smaken) {
    return 0;
  }
  return parseInt(props.boxdata.pickedBox.product_options.aantal_smaken) || 0;
});

const flavours = computed(() => props.boxdata?.flavours || []);

const filteredFlavours = computed(() => {
  if (!props.flavors) return [];
  
  // Filter out required flavors and apply vegan filter if needed
  let filtered = props.flavors.filter(flavor => !flavor.required);
  
  if (veganOnly.value) {
  filtered = filtered.filter(flavour => flavour.vegan === '1');
}

  
  return filtered;
});

// Justin added .lenght so you can add multiple flavors of the same type
function isFlavorSelected(flavor) {
  return flavours.value.some(f => f.id === flavor.id).length;
}

function handleFlavorClick(flavour) {
  if (!flavour.required && !isFlavorSelected(flavour)) {
    // Add the flavor to the selected set
    selectedFlavors.value.add(flavour.id);
    
    // Emit the pick flavor event
    emit('pickflavour', flavour);
    
    // Remove the selection highlight after a delay
    setTimeout(() => {
      selectedFlavors.value.delete(flavour.id);
    }, 800); // 800ms delay for clear visual feedback
  }
}

const syncVeganOnly = (value) => {
  if (veganOnly.value !== value) {
    veganOnly.value = value;
  }
};

watch(
  veganOnly,
  (newVal) => {
    emit('update:veganOnly', newVal);
  }
);

watch(
  [path, () => props.boxdata.pickedBox?.title],
  ([newPath, newTitle]) => {
    if (
      (newPath && newPath.toLowerCase().includes('vegan')) ||
      (newTitle && newTitle.toLowerCase().includes('vegan'))
    ) {
      syncVeganOnly(true);
    } else {
      syncVeganOnly(false);
    }
  }
);

watch(
  () => props.boxdata.flavours,
  () => {
    flavorError.value = flavours.value.length < boxSize.value;
  },
  { deep: true }
);

watch(
  () => props.flavors,
  (newFlavors) => {
    if (newFlavors?.length && props.boxdata?.pickedBox) {
      const requiredFlavors = newFlavors.filter(flavor => flavor.required);
      const currentFlavours = [...(props.boxdata.flavours || [])];
      let shouldUpdate = false;

      requiredFlavors.forEach(flavor => {
        if (!currentFlavours.find(f => f.id === flavor.id)) {
          currentFlavours.push(flavor);
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        emit('update:flavours', currentFlavours);
      }
    }
  },
  { immediate: true }
);

onMounted(() => {
  if (window.SweetVegan === 'true') {
    syncVeganOnly(true);
  }
});

watch(
  () => props.boxdata.veganOnly,
  (newVal) => {
    if (typeof newVal === 'boolean') {
      syncVeganOnly(newVal);
    }
  }
);
</script>

<style scoped>


.flavor-bg {
  background-color: #5677F0;
  width: 150px;
  height: 150px;
  min-width: 150px;
  min-height: 150px;
  max-width: 150px;
  max-height: 150px;
}



.bg-flavor {
  background-color: #395AD4;
  max-height: 210px;
  min-height: 210px;
}

.flavor-bg img {
  margin-bottom: 30px;
  min-width: 110%;
}

.switch {
  position: relative;
  display: inline-block;
  width: 54px;
  height: 30px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #395AD4;
}

input:focus + .slider {
  box-shadow: 0 0 1px #395AD4;
}

input:checked + .slider:before {
  -webkit-transform: translateX(24px);
  -ms-transform: translateX(24px);
  transform: translateX(24px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.flavor-text {
  text-transform: uppercase;
  line-height: 1.4rem;
  margin-top: -15px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 8px;
}

.px-1-5 {
  padding-right: 0.35rem;
  padding-left: 0.35rem;
}

.vegan-icon {
  margin-right: 42px;
  margin-top: 20px;
  width: 28px;
  height: 28px;
}

@media screen and (max-width: 400px) {
  .vegan-icon {
    margin-right: 80px;
    margin-top: 50px;
  }
}

.sd-smaak-close-btn {
  background-color: #FF4A4A;
  width: 28px;
  height: 28px;
}

.sd-smaak-close-btn i {
  z-index: 2;
  position: absolute;
  background: #fff;
  border-radius: 100%;
  display: flex;
  right: 5px;
  top: 5px;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-size: 11px;
  color: #ff4a4a;
  font-weight: 900;
  cursor: pointer;
  transition: all 0.3s;
}

.sd-smaak-close-btn i:hover {
  background-color: #ff4a4a;
  color: #fff;
}

.sd-smaak-tooltip {
  background-color: #FFF1E3;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  color: #000;
  height: 20px;
  font-size: 11px;
  transition: all 0.3s;
}

.sd-smaak-tooltip:hover {
  background-color: #ff4a4a;
  color: #fff;
}

.flavor-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

/* Extended selection feedback for all devices */
.flavor-selected {
  animation: pulseSelection 0.5s ease-in-out;
  outline-offset: 2px;
  transform: scale(1);
  transition: all 0.3s ease;
}

@keyframes pulseSelection {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.94);
  }
  100% {
    transform: scale(1);
  }
}

@media screen and (max-width: 400px) {
  .sd-smaak-vulvlak { 
    justify-content: center;
  }
}

@media (max-width: 600px) {
  .flavor-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 450px) {
  .flavor-grid {
    grid-template-columns: rep;
  }

  .flavor-bg {
    width: 100px;
    height: 100px;
    min-width: 100px;
    min-height: 100px;
    max-width: 100px;
    max-height: 100px;
  }

  .flavor-bg img {
    width: 50%;
  }

  .bg-flavor {
    padding: 10px;
    align-items: center !important;
    justify-content: center !important;
    min-height: 180px;
  }
  
  /* Enhanced mobile selection feedback with zoom animation only */
  .flavor-selected {
    animation: smoothZoomMobile 0.8s ease-out;
  }
  
  @keyframes smoothZoomMobile {
    0% {
      transform: scale(1);
    }
    15% {
      transform: scale(0.92);
    }
    30% {
      transform: scale(1.08);
    }
    45% {
      transform: scale(0.96);
    }
    60% {
      transform: scale(1.03);
    }
    80% {
      transform: scale(0.99);
    }
    100% {
      transform: scale(1);
    }
  }

  .sd-selected-flavor {
    width: 80px;
  }

  .picked-flavor-wrapper {
    width: 100px !important;
    max-width: 100px !important;
    min-width: 100px !important;
    margin-right: 10px;
    height: 100px !important;
    max-height: 100px !important;
    height: 100px !important;
  }

  .sd-smaak-tooltip {
    position: absolute; 
    top: 0px;
    margin-left: 15px;
    margin-top: 15px;
    left: 0px;
  }

  div .flavour-block .flavor-bg-example,
  .picked-flavor-wrapper[data-v-a8283458]{
    width: 100px;
    min-width: 100px;
    margin-right: 10px;
    height: 100px;
  }

  .flavor-btn {
    min-height: fit-content;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }

  .flavor-bg img {
    margin-bottom: 10px;
  }

  .vegan-icon {
    margin-top: 20px !important;
    margin-right: 20px !important;
    width: 24px;
  }

  .picked-flavor-wrapper {
    padding-bottom: 0px !important;
  }

  .picked-flavor-wrapper img {
    width: 90px !important;
  }

  .sd-smaak-close-btn {
    margin-top: 0px !important;
    margin-right: 0px !important;
  }
}

.flavor-bg-example {
  width: 150px;
  min-width: 150px;
  margin-right: 15px;
  height: 150px;
  background-size: cover;
  border-radius: 8px;
}

.flavor-bg-example > div {
  width: 40px;
  height: 40px;
}

.evj-selected-flavor {
  width: 120px;
}

.picked-flavor-wrapper {
  width: 150px;
  min-width: 150px;
  margin-right: 15px;
  height: 150px;
  background-color: #5677F0;
}

.font-anton {
  font-family: Anton-Regular !important;
}
</style>
